import {useEffect, useState} from "react";
import "assets/styles/components/header.scss";
import userProfile from "assets/svg/icon-user-profile.svg";
import arrowBottomProfile from "assets/svg/arrow-bottom-profile.svg";
import iconUserProfile from "assets/svg/icon-user-profile-two.svg";
import iconPenEdit from "assets/svg/pen-icon-edit-profile-user.svg";
import passwordImg from "assets/images/password.svg";
import iconExitEdit from "assets/svg/exit-icon-edit-profile-user.svg";
import {useLocation, useNavigate} from "react-router-dom";
import {
    addOpenDrawer,
    appSetFiscalYear,
    appSetFiscalYears,
    appSetModal,
    appSetToggle,
    setSecretView
} from "store/actions/appAction";
import {useDispatch, useSelector} from "react-redux";
import NotificationBox from "../simple/NotificationBox";
// @ts-ignore
import momentJalaali from "moment-jalaali";

import {IconButton, styled} from "@mui/material";
import HamburgerIcon from "assets/icons/HamburgerIcon";
import {setBusiness} from "store/actions/businessAction";
import appLogo from "assets/images/appLogo.svg";

const HeaderWrapper = styled("div")(({theme}) => ({
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    margin: "0 !important",
    background:
        "linear-gradient(90deg, rgb(255 255 255) 0%, #ffffff 100%),linear-gradient(180deg, rgb(253 253 253) 15.3%, rgb(255 255 255) 123.61%)",
    filter: "drop-shadow(0px 4px 30px rgba(95, 95, 95, 0.12))",
    height: "64px",
    zIndex: 20,
    padding: "24px",
}));
const Logo = styled("img")(({theme}) => ({
    height: "48px",
    width: "auto",
}));
const InfoProfile = styled("div")(({theme}) => ({
    // left: '-110px',
    top: "65px",
}));

export default function MobileHeader({isBusinessRoute}: { isBusinessRoute: boolean }) {
    // let forceUpdate = useForceUpdate();
    let location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [secret, setSecret] = useState(false);
    const [checked, setChecked] = useState(false);
    const [lastUpdate, setLastUpdate] = useState("");
    const [stepTwo, setStepTwo] = useState(false);
    const [stepThree, setStepThree] = useState(true);
    const [showInfo, setShowInfo] = useState(false);
    const [showSideNotif, setShowSideNotif] = useState(false);

    // @ts-ignore
    const toggle = useSelector((state) => state.appReducer.toggle);
    // @ts-ignore
    const authUser = useSelector((state) => state.appReducer.user);
    const nameUser = useSelector(
        // @ts-ignore
        (state) => state.appReducer.user?.firstName ?? ""
    );
    const familyUser = useSelector(
        // @ts-ignore
        (state) => state.appReducer.user?.lastName ?? ""
    );
    const userRole = useSelector(
        // @ts-ignore
        (state) => state.appReducer.user?.userRole ?? ""
    );

    const [toggleCurrency, setToggleCurrency] = useState(false);

    useEffect(() => {
        setChecked(navigator.onLine);
        window.addEventListener("online", () => setChecked(true));
        window.addEventListener("offline", () => {
            const now = momentJalaali().format("HH:mm");
            setLastUpdate(now);
            setChecked(false);
        });
    }, []);

    useEffect(() => {
        if (!toggle) setShowInfo(toggle);
    }, [toggle]);

    useEffect(() => {
        dispatch(setSecretView(secret));
    }, [secret]);

    const authRoutes = ["/auth/register", "/auth/login", "/auth/forgotPassword"];

    return (
        <>
            <div dir="ltr">
                <div className={showSideNotif ? "active-panel-notif" : "panel-notif"}>
                    <NotificationBox showSideNotif={showSideNotif} toggleNotif={setShowSideNotif}/>
                </div>
            </div>
            {authRoutes.includes(location.pathname) ? (
                <></>
            ) : (
                <HeaderWrapper>
                    {isBusinessRoute ? (
                        <div/>
                    ) : (
                        <IconButton
                            disableRipple
                            disableFocusRipple
                            onClick={() => dispatch(addOpenDrawer(true, "sidebarDrawer", "right"))}
                            sx={{width: 30, height: 30, padding: 0}}
                        >
                            <HamburgerIcon/>
                        </IconButton>
                    )}

                    <a
                        href="/"
                        onClick={(e) => {
                            dispatch(setBusiness(null));
                            dispatch(appSetFiscalYears([]));
                            dispatch(appSetFiscalYear(null));
                            navigate("./");
                            e.preventDefault();
                        }}
                    >
                        <Logo src={appLogo}/>
                    </a>
                    {/* <div className="col-6 col-lg-1 col-md-1 col-sm-6 col-xs-6 nav-right">
                        <a href="/" onClick={(e) => {
                            dispatch(setBusiness(null))
                            navigate("./")
                            e.preventDefault()
                        }}>
                            <img
                                src={logo}
                                alt="logo"
                                style={{ cursor: "pointer" }}
                            />
                        </a>
                    </div> */}

                    <div className="condition">
                        <div className="profile-panle">
                            <div className="warp-user-profile " onClick={() => toggleProfile()}>
                                <div className="flex justify-center">
                                    <img src={userProfile} alt="userProfile" className="user-profile-img"/>
                                    <img src={arrowBottomProfile} alt="arrowBottomProfile"
                                         className="arrow-bottom-profile"/>
                                </div>
                                {toggle && showInfo ? (
                                    <InfoProfile className="warp-info-profile">
                                        <div className="header-profile">
                                            <div className="box-icon-profile">
                                                <img src={iconUserProfile} alt="iconUserProfile"/>
                                            </div>
                                            <div className="name-profile-user">{nameUser + " " + familyUser}</div>
                                            <div className="type-profile-user">{userRole}</div>
                                        </div>
                                        <div className="body-profile">
                                            <a
                                                className="item-body-profile"
                                                href="/profile"
                                                onClick={(e) => {
                                                    navigate("./profile");
                                                    e.preventDefault();
                                                }}
                                            >
                                                <img src={iconPenEdit} alt="iconPenEdit"/>
                                                <div>پروفایل / تغییر رمز</div>
                                            </a>
                                            <a
                                                className="item-body-profile"
                                                onClick={() =>
                                                    dispatch(
                                                        appSetModal(
                                                            {
                                                                component: "change-password",
                                                                title: "تغییر رمز عبور",
                                                                closeButton: true,
                                                            },
                                                            true
                                                        )
                                                    )
                                                }
                                            >
                                                <img src={passwordImg} alt="iconPenEdit"/>
                                                <div>تغییر رمز</div>
                                            </a>
                                            <a
                                                href="/auth/logout"
                                                className="item-body-profile-exit"
                                                onClick={(e) => {
                                                    navigate("/auth/logout");
                                                    e.preventDefault();
                                                }}
                                            >
                                                <div className="line-item-exit"></div>
                                                <img src={iconExitEdit} alt="iconExitEdit"/>
                                                <div>خروج از حساب</div>
                                            </a>
                                        </div>
                                    </InfoProfile>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    </div>
                </HeaderWrapper>
            )}
        </>
    );

    // start func toggle secret
    function switchSecret() {
        setSecret(!secret);
    }

    // the end func toggle secret

    // start func toggleProfile
    function toggleProfile() {
        dispatch(appSetToggle(!showInfo));
        setShowInfo(!showInfo);
    }

    function toggleCurrencyConverter() {
        // dispatch(appSetToggle(!showInfo))
        setToggleCurrency(!toggleCurrency);
    }

    // the end func toggleProfile

    function switchChecked() {
        setChecked(!checked);
        setStepTwo(!stepTwo);
        // setTimeout(() => {
        //   setStepTwo(!stepTwo)
        // }, 1000);
        // forceUpdate();
    }

    // function logOut() {
    //     // dispatch(setUser(null));
    //     navigate("/auth/logout");
    // }
}
